import React, { Component } from "react";
import Axios from "axios";
import FoldersTable from "./FoldersTable";
import CampaignsTable from "./CampaignsTable";
import CreateFolderForm from "./CreateFolderForm";
import loadingSvg from "../../images/loading.svg";
import CreateCampaignButton from "./CreateCampaignButton";

export default class CampaignsView extends Component {
    state = {
        campaigns: null,
        folder: {},
    };

    componentDidMount() {
        this.getRootFolderAPI();
    }

    getRootFolderAPI() {
        Axios.get(process.env.REACT_APP_BACKEND_URL + "/folder/root").then(response => {
            this.setState({ 
                campaigns: response.data?.campaigns,
                folder: response.data,
            });
        }).catch(error => {
            console.log(error);
            if (error?.response) {
                this.setState({ campaignGetError: error.response.data.message });
            }
        });
    }

    render() {
        const { campaigns, folder} = this.state;

        return campaigns ?
            <div className="container-md pt-5">
                <div className="d-flex justify-content-between flex-wrap">
                    <h1>Campaigns</h1>
                    <div>
                        <CreateCampaignButton createParams={{ folderId: folder?.id}} />
                    </div>
                </div>
                <FoldersTable 
                    folders={folder?.subfolders || []} 
                    refetchData={this.getRootFolderAPI.bind(this)}
                />
                <CreateFolderForm
                    folderId={folder?.id}
                    refetchData={this.getRootFolderAPI.bind(this)}
                />
                <CampaignsTable 
                    campaigns={campaigns || []} 
                    subfolders={folder?.subfolders || []} 
                    refetchData={this.getRootFolderAPI.bind(this)}
                />
                {!campaigns?.length ?
                    <h4 className="mt-5 pt-5 pb-5 text-center w-100 ft-lg">No Campaigns Have Been Created</h4>
                    : <></>
                }
                <div className="mt-5 text-center">
                    <CreateCampaignButton />
                </div>

            </div> : (
                <div className="full-loading-screen">
                    <div>
                        <img src={loadingSvg} alt="loading icon" />
                        <h4>Loading Campaigns...</h4>
                    </div>
                </div>
            )
    }
}